import {css} from "@panda/css";

import {AdditionalSpaceListItem} from "./PropertyAdditionalSpacesListItem";
import {ISpace} from "./PropertyDetailAdditionalSpaces";

interface IProps {
    additionalSpaces: ISpace[];
    onSpaceSelect: (space: ISpace) => void;
}

export const PropertyAdditionalSpacesList = ({additionalSpaces, onSpaceSelect}: IProps) => {
    return (
        <ul className={listStyle}>
            {additionalSpaces
                .sort((a, b) => (a.is_mandatory === b.is_mandatory ? 0 : a.is_mandatory ? -1 : 1))
                .map((space) => {
                    return <AdditionalSpaceListItem key={space.id} space={space} onSpaceSelect={() => onSpaceSelect(space)} />;
                })}
        </ul>
    );
};

const listStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    listStyle: "none",
    padding: 0
});
import {css} from "@panda/css";

import {AdditionalSpaceListItem} from "./PropertyAdditionalSpacesListItem";
import {ISpace} from "./PropertyDetailAdditionalSpaces";

interface IProps {
    additionalSpaces: ISpace[];
    onSpaceSelect: (space: ISpace) => void;
}

export const PropertyAdditionalSpacesList = ({additionalSpaces, onSpaceSelect}: IProps) => {
    return (
        <ul className={listStyle}>
            {additionalSpaces
                .sort((a, b) => (a.is_mandatory === b.is_mandatory ? 0 : a.is_mandatory ? -1 : 1))
                .map((space) => {
                    return <AdditionalSpaceListItem key={space.id} space={space} onSpaceSelect={() => onSpaceSelect(space)} />;
                })}
        </ul>
    );
};

const listStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    listStyle: "none",
    padding: 0
});
